import forms from '@/libs/forms';

const getPaymentFields = (showAccountType, showOptionField, paymentMethodType) => {
  const nameField = forms.simpleInput(
    'text',
    'Name (Identifier)',
    null,
    'name',
    true,
  );
  nameField.hint = 'Try to use a name that you will easily associate with this payment method.';

  const optionField = forms.radios(
    'Payment Type',
    'method',
    true,
    [
      { value: 'transfer', name: 'Wire Transfer' },
      { value: 'ach', name: 'ACH Transaction' },
    ],
    12,
    'bool-radio',
  );
  optionField.onChanged = (model) => {
    /* eslint no-param-reassign: ["error", { "props": false }] */
    model.ach = {};
    model.transfer = {};
  };


  const checkMethod = (model, value) => {
    try {
      return model.method === value;
    } catch (_) { return false; }
  };
  const transferVisible = model => checkMethod(model, 'transfer');
  const achVisible = model => checkMethod(model, 'ach');

  const getBankFields = (method, isVisible) => {
    const bankName = forms.simpleInput(
      'text', 'Name of Bank', null, `${method}.bankName`, true, 12, null, isVisible,
    );
    const bankAddress = forms.splitAddress('Bank Address', `${method}.bankAddress`, isVisible);
    const routingNumber = forms.simpleInput(
      'text', 'ABA/Routing Number for Incoming Wire Transfers',
      null, `${method}.routingNumber`, true, 12, null,
      isVisible,
    );
    const accountNumber = forms.simpleInput(
      'text', 'Account Number', null,
      `${method}.accountNumber`,
      true, 12, null, isVisible,
    );
    const accountName = forms.simpleInput(
      'text', 'Name on Account (must be exact)',
      null, `${method}.accountName`, true,
      12, null, isVisible,
    );
    const recipientAddress = forms.splitAddress(
      'Recipient Address (must match bank records)',
      `${method}.recipientAddress`, isVisible,
    );

    bankName.maxlength = 100;
    accountName.maxlength = 100;
    accountNumber.maxlength = 20;
    routingNumber.maxlength = 20;
    const fields = [bankName, bankAddress, routingNumber,
      accountNumber, accountName, recipientAddress];
    if (showAccountType) {
      const accountTypeField = forms.radios(
        'Account Type',
        `${method}.accountType`,
        true,
        [
          { value: 'checking', name: 'Checking' },
          { value: 'savings', name: 'Savings' },
        ],
        12,
        'bool-radio',
        null,
        isVisible,
      );
      fields.unshift(accountTypeField);
    }
    return fields;
  };

  const transferFields = getBankFields('transfer', transferVisible);
  const achFields = getBankFields('ach', achVisible);
  const fields = [nameField, optionField].concat(transferFields, achFields);
  if (!showOptionField) {
    fields.splice(1, 1);
  }

  let authorizationVerbiage = '';
  if (paymentMethodType === 'ACH') {
    authorizationVerbiage = `
      By marking this checkbox, you are confirming that you are authorizing Anchor
      Loans, LP to a one-time withdrawal of funds in the amount specified above from
      the account listed above.
    `;
  } else if (paymentMethodType === 'Draw') {
    authorizationVerbiage = `
      By marking this checkbox you are confirming that you are an authorized signatory
      for the above mentioned entity and authorize Anchor Loans LP to release
      construction holdback funds to the above account, in accordance with the Construction Holdback Agreement.
    `;
  }
  return fields.concat(
    forms.checkbox(
      authorizationVerbiage,
      'authorized', null, true,
    ),
  );
};


export default {
  schema: (showAccountType, showOptionField, paymentMethodType) => ({
    fields: getPaymentFields(showAccountType, showOptionField, paymentMethodType),
  }),
  options: forms.options('new-payment-method-', true),
};



// WEBPACK FOOTER //
// ./src/components/payments/create/resources/schema.js